import React, { useState } from "react";
import styles from "./userTable.module.css";
import { Pagination } from "antd";
import store from "../../../src/Store/Store";
import EditUser from "./EditUser";

const UserTable = ({ data, title, loading, setRefreshData }) => {
  const [serchFilter, setSerchFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [noData, setNoData] = useState(false);
  const [editUser, setEdituser] = useState(false);

  const filteredData = data.filter(
    (user) =>
      user.user_full_name.toLowerCase().includes(serchFilter.toLowerCase()) ||
      user.user_mobile_no.toLowerCase().includes(serchFilter.toLowerCase()) ||
      user.tags.toLowerCase().includes(serchFilter.toLowerCase()) ||
      user.user_email.toLowerCase().includes(serchFilter.toLowerCase()) ||
      user.roles.includes(serchFilter.toUpperCase())
  );

  const startIndex = (currentPage - 1) * pageSize;
  let currentPageData = filteredData
    .reverse()
    .slice(startIndex, startIndex + pageSize);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <>
      <div className={styles.frameGroup}>
        <div className={styles.feeStatementDataTable}>
          <div className={styles.top}>
            <div className={styles.filterWrapper}>
              <div className={styles.filter}>
                <div className={styles.containertext}> {title}</div>{" "}
              </div>
              <div className={styles.filter}>
                <div className={styles.textField}>
                  <div className={styles.content}>
                    <img
                      className={styles.leadingIcon}
                      alt=""
                      src="/leadingicon.svg"
                    />
                    <input
                      className={styles.labelText1}
                      placeholder="Search..."
                      type="text"
                      value={serchFilter}
                      onChange={(e) => {
                        setSerchFilter(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <button
                  className={styles.reLoadTable}
                  onClick={() => {
                    if (refresh) {
                      setRefresh(false);
                      return;
                    }
                    setRefresh(true);
                  }}
                >
                  <img
                    className={styles.vectorIcon1}
                    alt=""
                    src="/vector7.svg"
                  />
                </button>
              </div>
            </div>
            <div className={styles.topChild} />
          </div>
          <table className={styles.table}>
            <thead className={styles.tableHead}>
              <tr className={styles.tableHeaderRow}>
                <th className={styles.tableHeaderRowCell}>
                  <div className={styles.head}>CREATED AT</div>
                </th>
                <th className={styles.tableHeaderRowCell}>
                  <div className={styles.head}>NAME</div>
                </th>

                <th className={styles.tableHeaderRowCell}>
                  <div className={styles.head}>EMAIL</div>
                </th>
                <th className={styles.tableHeaderRowCell}>
                  <div className={styles.head}>PHONE NO</div>
                </th>
                <th className={styles.tableHeaderRowCell}>
                  <div className={styles.head}>KYC STATUS</div>
                </th>
                <th className={styles.tableHeaderRowCell}>
                  <div className={styles.head}>ACTION</div>
                </th>
              </tr>
            </thead>
            <tbody className={styles.tableHead}>
              {currentPageData.map((detail, index) => (
                <tr key={index} className={styles.tableBodyrow}>
                  <td
                    className={styles.tableBodydatabtn}
                    //   onClick={() => {
                    //     console.log("gotit");
                    //     store.setSelectedExpenseMobileNo(detail.mobile_no);
                    //     navigate("/content/transactions");
                    //   }}
                  >
                    <div className={styles.data12}>{detail.created_at}</div>
                  </td>
                  <td className={styles.tableBodydata}>
                    {" "}
                    <div className={styles.data1}>{detail.user_full_name}</div>
                  </td>
                  <td className={styles.tableBodydata}>
                    {" "}
                    <div className={styles.data1}>
                      {detail?.user_email == "undefined"
                        ? "-"
                        : detail?.user_email || "-"}
                    </div>
                  </td>
                  <td className={styles.tableBodydata}>
                    {" "}
                    <div className={styles.data1}>{detail.user_mobile_no}</div>
                  </td>

                  <td className={styles.tableBodydata}>
                    {" "}
                    <div className={styles.data1}>{detail.status}</div>
                  </td>
                  <td className={styles.tableBodydata}>
                    <button
                      className={styles.button}
                      onClick={() => {
                        store.setUserId(detail.user_id);
                        store.setName(detail.user_full_name);
                        store.setSelectedEmail(detail.user_email);
                        store.setTxnLimit(detail.perTxnLimit);
                        store.setDailyLimit(detail.dailyLimit);
                        store.setmonthlyLimit(detail.monthlyLimit);
                        store.setCreate_at(detail.created_at);
                        store.setPhoneNo(detail?.user_mobile_no);
                        store.setStatus(detail?.status);
                        store.setEnabled(true);
                        store.setUserRoles(detail?.roles);
                        store.setTags(detail?.tags?.split(","));
                        setEdituser(true);
                      }}
                    >
                      <img
                        alt=""
                        src="/edit-02.svg"
                        className={styles.btn_img}
                      />
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {noData && <div className={styles.noHistory}>No Users found .</div>}
          <div className={noData ? styles.bottom1 : styles.bottom}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={filteredData.length}
              onChange={handlePaginationChange}
              // showSizeChanger
            />
          </div>
        </div>
      </div>
      <div></div>
      {editUser && (
        <div
          className={styles.ViewUserHeader}
          onClick={() => {
            setEdituser(false);
          }}
        >
          <EditUser
            isVisible={editUser}
            setRefreshData={setRefreshData}
            onClose={() => {
              setEdituser(false);
            }}
          />
        </div>
      )}
    </>
  );
};

export default UserTable;
